import { render, staticRenderFns } from "./instForm.vue?vue&type=template&id=a600969e&scoped=true"
import script from "./instForm.vue?vue&type=script&lang=js"
export * from "./instForm.vue?vue&type=script&lang=js"
import style0 from "./instForm.vue?vue&type=style&index=0&id=a600969e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a600969e",
  null
  
)

export default component.exports